import { render, staticRenderFns } from "./enCourseData.vue?vue&type=template&id=5aefe56e&scoped=true&"
import script from "./enCourseData.vue?vue&type=script&lang=js&"
export * from "./enCourseData.vue?vue&type=script&lang=js&"
import style0 from "./enCourseData.vue?vue&type=style&index=0&id=5aefe56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefe56e",
  null
  
)

export default component.exports